import React from 'react';

const SvgConfirm = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 96 96" ref={svgRef} {...props} fill="currentColor">
    <title>{title}</title>
    <path d="M63.4 31.7C41.9 61.7 30.2 78 29.3 78.9c-.2.3-4.8-3.9-10.2-9.2C11.6 62.3 8.7 60 6.6 60 1.9 60 0 61.7 0 65.8c0 3.5 1 4.7 13.3 17 12 12 13.5 13.2 16.8 13.2 3.6 0 3.6 0 34.8-43.4C91 16.1 96 8.6 96 5.8 96 1.4 94.5 0 89.9 0h-3.8L63.4 31.7z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgConfirm svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Confirm.js